import { z } from 'zod';
import { UuidSchema } from './common.js';
// Período de nómina no formato AAAA-MM.
export const PeriodoSchema = z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'periodo debe ser AAAA-MM');
export const PlanillaEstadoSchema = z.enum(['abierta', 'cerrada']);
// Uma linha por guardia, espelhando 1:1 as colunas físicas da planilla.
// Montos como string (Decimal serializado em Gs inteiro).
export const PlanillaRenglonViewSchema = z.object({
    guardiaId: UuidSchema,
    nombre: z.string(),
    remuneracion: z.string(),
    diasTrab: z.string(),
    jornal: z.string(),
    salMes: z.string(),
    descUniformes: z.string(),
    descProyList: z.string(),
    anticipoMes: z.string(),
    anticipoSaldoAnt: z.string(),
    descCredCurso: z.string(),
    descMultas: z.string(),
    descMercaderias: z.string(),
    descAlqTaxiIps: z.string(),
    deudaAntConst: z.string(),
    totalDesc: z.string(),
    sCobrar: z.string(),
});
export const PlanillaViewSchema = z.object({
    periodo: PeriodoSchema,
    sucursalId: UuidSchema,
    sucursalNombre: z.string(),
    estado: PlanillaEstadoSchema,
    renglones: z.array(PlanillaRenglonViewSchema),
    totalAPagar: z.string(),
});
export const PlanillaQuerySchema = z.object({
    periodo: PeriodoSchema,
    sucursalId: UuidSchema,
});
// Total general consolidado (todas as sucursais) — restrito a superadmin.
export const PlanillaGeneralFilaSchema = z.object({
    sucursalId: UuidSchema,
    sucursalNombre: z.string(),
    cantGuardias: z.number().int(),
    totalAPagar: z.string(),
});
export const PlanillaGeneralViewSchema = z.object({
    periodo: PeriodoSchema,
    sucursales: z.array(PlanillaGeneralFilaSchema),
    totalGeneral: z.string(),
});
export const PlanillaGeneralQuerySchema = z.object({
    periodo: PeriodoSchema,
});
// Registro do pago dispara o cierre por snapshot do período/sucursal.
export const PlanillaCierreRequestSchema = z.object({
    periodo: PeriodoSchema,
    sucursalId: UuidSchema,
});
// Descuentos parcelados (uniformes/mercaderías/otros) em cuotas mensais.
export const DescuentoParceladoTipoSchema = z.enum(['uniforme', 'mercaderia', 'otros']);
// Subtipos de "otros" com coluna física própria no PDF (T-013).
export const DescuentoParceladoCategoriaSchema = z.enum(['proy_list', 'cred_curso', 'alq_taxi_ips']);
export const DescuentoParceladoRequestSchema = z.object({
    guardiaId: UuidSchema,
    tipo: DescuentoParceladoTipoSchema,
    categoria: DescuentoParceladoCategoriaSchema.nullish(),
    origenInventarioId: UuidSchema.nullish(),
    descripcion: z.string().max(200).nullish(),
    valorTotal: z.string().regex(/^\d+(\.\d{1,2})?$/, 'valorTotal debe ser numérico'),
    numCuotas: z.number().int().min(1).max(60),
    periodoInicial: PeriodoSchema,
});
export const DescuentoCuotaViewSchema = z.object({
    periodo: PeriodoSchema,
    monto: z.string(),
});
export const DescuentoParceladoViewSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    tipo: DescuentoParceladoTipoSchema,
    valorTotal: z.string(),
    numCuotas: z.number().int(),
    montoCuota: z.string(),
    cuotas: z.array(DescuentoCuotaViewSchema),
});
// Detalhe para a ficha do guardia: inclui id + estado da cuota (necessário p/ reprogramar).
export const DescuentoCuotaDetailSchema = z.object({
    id: UuidSchema,
    periodo: PeriodoSchema,
    monto: z.string(),
    estado: z.string(), // pendiente | descontada
});
export const DescuentoParceladoDetailSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    tipo: DescuentoParceladoTipoSchema,
    categoria: z.string().nullable(),
    descripcion: z.string().nullable(),
    valorTotal: z.string(),
    numCuotas: z.number().int(),
    montoCuota: z.string(),
    estado: z.string(),
    cuotas: z.array(DescuentoCuotaDetailSchema),
});
export const DescuentoParceladoListQuerySchema = z.object({ guardiaId: UuidSchema });
// Multa pontual debitada na planilla do período (descMultas).
export const MultaRequestSchema = z.object({
    guardiaId: UuidSchema,
    monto: z.string().regex(/^\d+(\.\d{1,2})?$/, 'monto debe ser numérico'),
    descripcion: z.string().max(200).nullish(),
    periodo: PeriodoSchema,
});
export const MultaViewSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    monto: z.string(),
    descripcion: z.string().nullable(),
    periodo: PeriodoSchema,
    createdAt: z.string().nullable(),
});
export const MultaListQuerySchema = z.object({
    guardiaId: UuidSchema,
    periodo: PeriodoSchema.optional(),
});
//# sourceMappingURL=planilla.js.map